import { createElement, useState, useEffect } from 'react';
import { flushSync } from 'react-dom';
import { PlusOutlined } from '@ant-design/icons';
import { Modal, Upload, message } from 'antd';
import { isDef, isArr } from '../../utils';
const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});
const UploadImage = ({ maxLength = 1, axiosDataSource, disabled = false, kbSize = 5 * 1024, onChange, value }) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const { fileList, setFileList } = useValue(value);
    const handleCancel = () => {
        setPreviewOpen(false);
    };
    const handlePreview = async (file) => {
        console.log('file', file);
        setPreviewOpen(true);
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const getValue = (list) => {
        if (list.length > 1) {
            return list.map(item => {
                return item.url;
            });
        }
        return list[0].url || '';
    };
    const handleRemove = (file) => {
        console.log('file', file);
        const index = fileList.findIndex(f => f.uid === file.uid);
        if (index !== -1) {
            fileList.splice(index, 1);
            const list = [...fileList];
            setFileList(list);
            onChange && onChange(getValue(list));
            return true;
        }
        return false;
    };
    const beforeUpload = (file) => {
        console.log('kbSize', file, file.size > 1024 * kbSize);
        const check = file.size > 1024 * kbSize;
        const showSize = kbSize > 1024 ? `${Number(kbSize / 1024).toFixed(2)}MB` : `${kbSize}KB`;
        if (check) {
            message.error(`上传的图片不可超过${showSize}`);
        }
        return check && Upload.LIST_IGNORE;
    };
    const handleChange = (info) => {
        flushSync(async () => {
            console.log('info', info, fileList, !fileList.some(file => file.uid === info.file.uid));
            if (info.file.uid && !fileList.some(file => file.uid === info.file.uid)) {
                const formData = new FormData();
                formData.append('file', info.file);
                if (!axiosDataSource) {
                    console.error('请先绑定数据源');
                    return;
                }
                const res = await axiosDataSource.load({
                    formData,
                });
                const list = [...fileList, { uid: info.file.uid, name: res.fileName, url: res.fullPath }];
                setFileList(list);
                onChange && onChange(getValue(list));
            }
        });
    };
    const uploadButton = (createElement("div", null,
        createElement(PlusOutlined, null),
        createElement("div", { style: { marginTop: 8 } }, "\u4E0A\u4F20")));
    return createElement("div", { className: `upload-image-material ${disabled && 'disabled'}` },
        createElement(Upload, { listType: "picture-card", accept: "image/*", fileList: fileList, disabled: disabled, beforeUpload: beforeUpload, onPreview: handlePreview, onChange: handleChange, onRemove: handleRemove, customRequest: () => { } }, fileList.length >= maxLength ? null : uploadButton),
        createElement(Modal, { getContainer: false, open: previewOpen, title: previewTitle, footer: null, onCancel: handleCancel },
            createElement("img", { alt: "", style: { width: '100%' }, src: previewImage })));
};
function useValue(valueProp) {
    const [value, setValue] = useState([]);
    useEffect(() => {
        if (isDef(valueProp)) {
            if (typeof valueProp === 'string') {
                setValue([{ url: valueProp, name: valueProp.substring(valueProp.lastIndexOf('/') + 1), uid: 0 }]);
            }
            else if (isArr(valueProp)) {
                const res = valueProp.map((url, index) => {
                    return { url, name: url.substring(url.lastIndexOf('/') + 1), uid: index };
                });
                setValue(res);
            }
        }
    }, [valueProp]);
    return { fileList: value, setFileList: setValue };
}
UploadImage.displayName = 'UploadImage';
export default UploadImage;
